import React, { memo } from 'react';
import {
  ChartComponent,
  SeriesCollectionDirective,
  Inject,
  Legend,
  Category,
  DateTime,
  DataLabel,
  Highlight,
  Tooltip,
  AreaSeries,
} from '@syncfusion/ej2-react-charts';
import PropTypes from 'prop-types';

const AreaChartComponent = ({ chartResult, chartPalette, renderSeries, generateAxis, jobId, chartType }) => {
  const { primaryXAxis, primaryYAxis, axes = [] } = generateAxis({ chartType });
  const { queryConstruct } = chartResult?.query || {};
  const qcChart = queryConstruct.chart;

  return (
    <ChartComponent
      id={`chart-${jobId}`}
      width="100%"
      height="100%"
      style={{ textAlign: 'center' }}
      legendSettings={
        qcChart?.format.legend
          ? {
              visible: true,
              enableHighlight: true,
              textWrap: 'Wrap',
              position: 'Bottom',
              alignment: 'Near',
              containerPadding: { top: 20 },
              itemPadding: 0,
              padding: 10,
            }
          : {}
      }
      primaryXAxis={primaryXAxis}
      primaryYAxis={primaryYAxis}
      axes={axes}
      chartArea={{ border: { width: 0 } }}
      tooltip={{ enable: true }}
      palettes={chartPalette}>
      <Inject services={[AreaSeries, Legend, Tooltip, Category, DateTime, DataLabel, Highlight]} />
      <SeriesCollectionDirective>
        {chartResult?.queryResult?.map((series, i) => {
          return renderSeries({ series, type: 'Area', index: i, qcChart });
        })}
      </SeriesCollectionDirective>
    </ChartComponent>
  );
};

AreaChartComponent.propTypes = {
  data: PropTypes.object,
  renderSeries: PropTypes.func.isRequired,
  chartPalette: PropTypes.array.isRequired,
  generateAxis: PropTypes.func.isRequired,
  chartResult: PropTypes.object,
  jobId: PropTypes.string.isRequired,
  chartType: PropTypes.string.isRequired,
};

export default memo(AreaChartComponent);
